export function calculateArticlePurchaseVatAmount(
  amountExVat: number | null | undefined,
  taxPercentage: number | null | undefined
): number | null {
  if (amountExVat === null || amountExVat === undefined) {
    return null
  }

  return amountExVat * ((taxPercentage ?? 0) / 100)
}

export function calculateArticlePurchaseTotalAmount(
  amountExVat: number | null | undefined,
  taxPercentage: number | null | undefined
): number | null {
  if (amountExVat === null || amountExVat === undefined) {
    return null
  }

  return (
    amountExVat +
    (calculateArticlePurchaseVatAmount(amountExVat, taxPercentage) ?? 0)
  )
}
